if (!customElements.get('kit-country-picker')) {
  customElements.define(
    'kit-country-picker',
    class KitCountryPicker extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.handleClick = this.onClick.bind(this);
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      onClick(event) {
        const link = event.target.closest('a[data-kit-product-id]');
        if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 ||
          event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (link.dataset.kitProductId === this.productInfo.dataset.productId) {
          event.preventDefault();
          return;
        }
        let sizes;
        try {
          sizes = JSON.parse(link.dataset.kitSizeVariants);
        } catch {
          return;
        }
        const size = this.productInfo.querySelector('[data-kit-option="size"] input:checked')?.value;
        const variantId = sizes[size] || link.dataset.kitDefaultVariant;
        if (!variantId) return;
        event.preventDefault();
        link.dataset.kitVariantId = variantId;
        this.querySelector('[data-kit-switch-error]').hidden = true;
        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: { event, target: link, selectedOptionValues: [] },
        });
      }
    }
  );
}

if (!customElements.get('kit-personalization')) {
  customElements.define(
    'kit-personalization',
    class KitPersonalization extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.form = this.closest('form');
        this.nameInput = this.querySelector('[data-kit-name]');
        this.numberInput = this.querySelector('[data-kit-number]');
        this.handleInput = this.onInput.bind(this);
        this.handleSubmit = this.onSubmit.bind(this);
        this.handleInvalid = this.onInvalid.bind(this);
        this.handleOptionChange = this.updateSummary.bind(this);
        this.addEventListener('input', this.handleInput);
        this.form.addEventListener('submit', this.handleSubmit, true);
        this.form.addEventListener('invalid', this.handleInvalid, true);
        this.productInfo.addEventListener('change', this.handleOptionChange);
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId === this.dataset.sectionId) this.updateSummary();
        });
        this.updateSummary();
      }

      disconnectedCallback() {
        this.removeEventListener('input', this.handleInput);
        this.form?.removeEventListener('submit', this.handleSubmit, true);
        this.form?.removeEventListener('invalid', this.handleInvalid, true);
        this.productInfo?.removeEventListener('change', this.handleOptionChange);
        this.unsubscribeVariant?.();
      }

      onInput(event) {
        const input = event.target;
        if (input === this.nameInput && !event.isComposing) {
          const start = input.selectionStart;
          const end = input.selectionEnd;
          input.value = input.value.toLocaleUpperCase('it').slice(0, input.maxLength);
          input.setSelectionRange(start, end);
        }
        if (input === this.nameInput || input === this.numberInput) {
          input.setCustomValidity('');
          this.setFieldError(input, false);
        }
        this.updateSummary();
      }

      onInvalid(event) {
        if (!this.contains(event.target)) return;
        this.setFieldError(event.target, true);
        event.target.scrollIntoView({ block: 'center', behavior: 'instant' });
      }

      setFieldError(input, invalid) {
        const errorId = input === this.nameInput ? 'KitNameError' : 'KitNumberError';
        const error = this.querySelector(`#${errorId}-${this.dataset.sectionId}`);
        if (error) error.hidden = !invalid;
        if (invalid) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
      }

      onSubmit(event) {
        this.nameInput.value = this.nameInput.value.trim().toLocaleUpperCase('it');
        this.numberInput.value = this.numberInput.value.trim();
        if (!this.form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.form.reportValidity();
          return;
        }
        this.updateSummary();
      }

      updateSummary() {
        this.querySelector('[data-kit-name-count]').textContent = `${this.nameInput.value.length}/${this.nameInput.maxLength}`;
        this.querySelector('[data-kit-summary-name]').textContent = this.nameInput.value.trim().toLocaleUpperCase('it') || 'Da scegliere';
        this.querySelector('[data-kit-summary-number]').textContent = this.numberInput.value || 'Da scegliere';
        this.productInfo.querySelectorAll('variant-selects fieldset').forEach((fieldset, index) => {
          const selected = fieldset.querySelector('input:checked');
          const summary = this.querySelector(`[data-kit-summary-option="${index + 1}"]`);
          if (selected && summary) summary.textContent = selected.value;
        });
        const complete = this.nameInput.value.trim() !== '' && this.nameInput.validity.valid && this.numberInput.validity.valid;
        const status = this.querySelector('[data-kit-status]');
        status.textContent = complete ? 'Personalizzazione pronta' : 'Da personalizzare';
        status.classList.toggle('is-complete', complete);
      }
    }
  );
}
